var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKnapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 3648.496,
    height: 1162.673,
    viewBox: "0 0 3648.496 1162.673",
    enableBackground: "new 0 0 3648.496 1162.673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1D1D1B",
    points: "3.721,911.631 3.721,250.396 91.226,250.396    91.226,578.306 419.588,250.396 538.213,250.396 260.818,518.316 550.391,911.631 434.922,911.631 199.475,576.954 91.226,682.5    91.226,911.631  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1D1D1B",
    points: "750.205,911.631 750.205,250.396 839.964,250.396    1187.273,769.551 1187.273,250.396 1271.167,250.396 1271.167,911.631 1181.409,911.631 834.102,392.026 834.102,911.631  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1D1D1B",
    d: "M2399.995,911.631V250.396h249.424   c43.897,0,77.432,2.114,100.586,6.313c32.476,5.415,59.678,15.786,81.642,31.123c21.942,15.039,39.535,36.24,52.772,63.599   c13.53,27.373,20.298,57.436,20.298,90.21c0,56.24-17.904,103.896-53.677,142.983c-35.786,38.784-100.439,58.179-193.95,58.179   h-169.595v268.828H2399.995z M2487.495,564.775h170.948c56.522,0,96.664-10.512,120.429-31.572   c23.75-21.045,35.62-50.659,35.635-88.857c0-27.656-7.075-51.265-21.201-70.816c-13.838-19.843-32.178-32.924-55.028-39.238   c-14.742-3.906-41.949-5.85-81.637-5.864h-169.146V564.775z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1D1D1B",
    d: "M3143.77,911.631V250.396h249.434   c43.892,0,77.422,2.114,100.581,6.313c32.476,5.415,59.678,15.786,81.641,31.123c21.943,15.039,39.536,36.24,52.773,63.599   c13.53,27.373,20.298,57.436,20.298,90.21c0,56.24-17.905,103.896-53.676,142.983c-35.787,38.784-100.445,58.179-193.951,58.179   h-169.594v268.828H3143.77z M3231.275,564.775h170.946c56.523,0,96.665-10.512,120.431-31.572   c23.75-21.045,35.619-50.659,35.634-88.857c0-27.656-7.08-51.265-21.201-70.816c-13.843-19.843-32.178-32.924-55.029-39.238   c-14.741-3.906-41.942-5.85-81.641-5.864h-169.14V564.775z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFED00",
    points: "2142.124,874.214 1514.986,874.214 1828.555,331.099  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M1795.222,311.856L1448.321,912.7h760.468l-380.234-658.579L1795.222,311.856z M1828.555,408.076   c46.914,81.253,199.99,346.396,246.904,427.651h-493.808C1628.562,754.473,1781.643,489.33,1828.555,408.076"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.476,
    y: 989.476,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#878787",
    width: 3648.56,
    height: 173.197
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#878787",
    width: 3648.691,
    height: 173.198
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnapp);
export default __webpack_public_path__ + "static/media/KNAPP.d355d75b242ff8d74cd514bf22eca7ef.svg";
export { ForwardRef as ReactComponent };